import { TransitionConfigOrTarget } from "xstate4"
import { Context, OrgFilterTransition, Transitions } from "../types"

type UpdateFiltersEvent = {
  UPDATE_FILTERS?: TransitionConfigOrTarget<
    Context,
    OrgFilterTransition,
    Transitions
  >
}

export const updateFiltersEvent: UpdateFiltersEvent = {
  UPDATE_FILTERS: {
    actions: ["setOrgFilters", "cancelFilterCheck", "updateFilterCheck"]
  }
}
